import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchTransactionHistorySuccess,
  fetchTransactionHistoryFailure,
} from '../actions';
import transactionHistoryTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* fetchTransactionHistory({ data }) {
  const { page = 0, size = 10, name, platform, status } = data;
  const url = `${API_BASE_URL}/payments?page=${page}&size=${size}${
    name ? `&name=${name}` : ''
  }${platform ? `&platform=${platform.toUpperCase()}` : ''}${
    status ? `&status=${status.toUpperCase()}` : ''
  }`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchTransactionHistorySuccess(response.raw));
  } else {
    yield put(
      fetchTransactionHistoryFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.statusCode, response?.message);

  }
}

export function* getTransactionHistory() {
  yield takeLatest(
    transactionHistoryTypes.FETCH_TRANSACTIONS_HISTORY_START,
    fetchTransactionHistory
  );
}
